export default __webpack_public_path__ + "static/media/Agent-ChatwootAssignment-Sample.b415e5e1.csv";